module.exports = __webpack_public_path__ + "style/img/Rectangle 4557@2x.6bffd940.png";